module.exports = __webpack_public_path__ + "img/2_Appendix.85dc4823.png";